import { mutatorAction } from 'satcheljs';
import { NativeAdTemplate } from '../../../../../@data';
import { getAdunitStore } from '../store/store';

export const setTemplate = mutatorAction('setTemplate', (template: NativeAdTemplate) => {
  getAdunitStore().template = template;
});
